import React, { Suspense, useEffect, useState } from "react";
// import ReactDOM from "react-dom";
import { BrowserRouter, Navigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";
import AlertView from "../components/Alert";
import LoaderView from "../components/Loader";
import { useSelector, useDispatch } from "react-redux";
import { getSessionDetails } from "../utils";
import { USER_DETAILS } from "../utils/constants";
import { setUserDetails } from "../redux/actions/user";
import { Spinner } from "@material-tailwind/react";

// Pagesss
const Login = React.lazy(() => import("../login"));
const ForgotPassword = React.lazy(() => import("../login/forgot-password"));
const UpdatePassword = React.lazy(() => import("../login/update-password"));
const DefaultLayout = React.lazy(() => import("../layout/DefaultLayout"));
const ViewCertificate = React.lazy(() => import("../admin/certificates/view"));

const Router = () => {
  const app = useSelector((state) => state.app);

  const user = useSelector((state) => state.user.userDetails);

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!user) {
      const sessionDetails = getSessionDetails(USER_DETAILS);
      if (sessionDetails) {
        dispatch(setUserDetails(sessionDetails.user));
      } else {
        dispatch(setUserDetails(undefined));
      }
    }
    setLoading(false);
  }, [dispatch]);

  if (!loading) {
    return (
      <Suspense
        fallback={
          <div className="flex justify-center items-center h-screen text-[25px]">
            Loading...
          </div>
        }
      >
        <React.Fragment>
          <BrowserRouter>
            <Routes>
              <Route
                exact
                path="/login"
                name="Login Page"
                element={<Login />}
              />
              <Route
                exact
                path="/forgot-password"
                name="Forgot Password"
                element={<ForgotPassword />}
              />
              <Route
                exact
                path="/update-password/:key"
                name="Update Password"
                element={<UpdatePassword />}
              />

              <Route
                exact
                path="/view-certificate/:type/:key"
                name="View Certificate"
                element={<ViewCertificate />}
              />
              <Route
                path="*"
                name="Home"
                element={
                  user ? <DefaultLayout /> : <Navigate to="/Login" replace />
                }
              />
            </Routes>
          </BrowserRouter>
          {app.error && <AlertView />}
          {app.loading && <LoaderView />}

          {app.loading && (
            <div
              className="absolute w-full h-[100vh] z-1 flex flex-row items-center justify-center "
              style={{ backgroundColor: "rgb(255, 255, 255, 0.8)" }}
            >
              <div className="h-[50px] bg-[#264390] rounded-sm flex flex-row items-center justify-center px-2 shadow-md">
                <Spinner className="h-8 w-8 text-white" color="blue" />
                {app?.loadingMessage && (
                  <div className="text-white ml-2">{app?.loadingMessage}</div>
                )}
              </div>
            </div>
          )}
        </React.Fragment>
      </Suspense>
    );
  } else {
    return (
      <div className="flex justify-center items-center h-screen">
        <p>Loading</p>
      </div>
    );
  }
};

export default Router;
